enum RouteEnum {
    home = '/',
    about = '/about',
    services = '/services',
    deedOfTemporaryGuardianship = '/deed-of-temporary-guardianship',
    enduringPowerOfAttorney = '/enduring-power-of-attorney',
    onlineWills = '/online-wills',
    estatePlanningSession = '/estate-planning-session',
    countrySpecificWills = '/country-specific-wills',
    premiumWills = '/premium-wills',
    listOfAssets = '/list-of-assets',
    charities = '/charities',
    blog = '/blog',
    willGuide = '/guide-how-do-i-write-my-will',
    contact = '/contact',
    helpCenter = '/help-center',
    privacyPolicy = '/privacy-policy',
    termsOfService = '/terms-of-service',
    comparison = '/comparison',
    whichWillServiceIsBestForMe = '/which-will-service-is-best-for-me',
    faqCountrySpecific = '/help-center/country-specific-will-service',
    faqDeedTemporary = '/help-center/temporary-guardianship-service',
    faqPowerOfAttorney = '/help-center/enduring-power-of-attorney',
    faqPremiumWill = '/help-center/premium-will-service',
    faqOnlineWill = '/help-center/online-will-service',
}

export default RouteEnum;
